import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { SettingsProvider } from "./lib/settings";
import { CartProvider } from "./lib/cart";
import LenisProvider, { ScrollToTop } from "./lib/lenis";
import { Toaster } from "sonner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Apply from "./pages/Apply";
import About from "./pages/About";
import Contact from "./pages/Contact";
import CatalogPublic from "./pages/CatalogPublic";
import Enquiry from "./pages/Enquiry";
import Banta from "./pages/Banta";
import PortalHome from "./pages/Portal";
import PortalOrders from "./pages/PortalOrders";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderPrint from "./pages/OrderPrint";
import {
  Overview, Retailers, Enquiries, Inquiries, Products, Orders as AdminOrders, Expiring, LowStock, Categories, Brands, Reviews, Settings as SettingsPage,
} from "./pages/Admin";

function Protected({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role === "admin" && user.role !== "admin") return <Navigate to="/portal" replace />;
  return children;
}

export default function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <LenisProvider>
              <ScrollToTop />
              <Toaster position="top-center" toastOptions={{ style: { borderRadius: 0, border: "1px solid #050505", background: "#F4F4F0", color: "#050505" } }} />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/about" element={<About />} />
                <Route path="/catalog" element={<CatalogPublic />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/enquiry" element={<Enquiry />} />
                <Route path="/banta" element={<Banta />} />
                <Route path="/login" element={<Login />} />
                <Route path="/apply" element={<Apply />} />
                <Route path="/portal" element={<Protected><PortalHome /></Protected>} />
                <Route path="/portal/orders" element={<Protected><PortalOrders /></Protected>} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Protected><Checkout /></Protected>} />
                <Route path="/order/:id/print" element={<Protected><OrderPrint /></Protected>} />
                <Route path="/admin" element={<Protected role="admin"><Overview /></Protected>} />
                <Route path="/admin/products" element={<Protected role="admin"><Products /></Protected>} />
                <Route path="/admin/low-stock" element={<Protected role="admin"><LowStock /></Protected>} />
                <Route path="/admin/expiring" element={<Protected role="admin"><Expiring /></Protected>} />
                <Route path="/admin/orders" element={<Protected role="admin"><AdminOrders /></Protected>} />
                <Route path="/admin/categories" element={<Protected role="admin"><Categories /></Protected>} />
                <Route path="/admin/brands" element={<Protected role="admin"><Brands /></Protected>} />
                <Route path="/admin/reviews" element={<Protected role="admin"><Reviews /></Protected>} />
                <Route path="/admin/retailers" element={<Protected role="admin"><Retailers /></Protected>} />
                <Route path="/admin/enquiries" element={<Protected role="admin"><Enquiries /></Protected>} />
                <Route path="/admin/inquiries" element={<Protected role="admin"><Inquiries /></Protected>} />
                <Route path="/admin/settings" element={<Protected role="admin"><SettingsPage /></Protected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </LenisProvider>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </SettingsProvider>
  );
}
